<script>

import { mapGetters } from 'vuex';

import { useUISettings } from 'dashboard/composables/useUISettings';

import { useAccount } from 'dashboard/composables/useAccount';

import ChatList from '../../../components/ChatList.vue';

import ConversationBox from '../../../components/widgets/conversation/ConversationBox.vue';

import wootConstants from 'dashboard/constants/globals';

import { BUS_EVENTS } from 'shared/constants/busEvents';

import CmdBarConversationSnooze from 'dashboard/routes/dashboard/commands/CmdBarConversationSnooze.vue';

import { emitter } from 'shared/helpers/mitt';

import SidepanelSwitch from 'dashboard/components-next/Conversation/SidepanelSwitch.vue';

import ConversationSidebar from 'dashboard/components/widgets/conversation/ConversationSidebar.vue';



export default {

  components: {

    ChatList,

    ConversationBox,

    CmdBarConversationSnooze,

    SidepanelSwitch,

    ConversationSidebar,

  },

  beforeRouteLeave(to, from, next) {

    if (this.currentRouteConversationId) {

      this.$store.dispatch('clearSelectedState');

    }

    next();

  },

  props: {

    inboxId: {

      type: [String, Number],

      default: 0,

    },

    conversationId: {

      type: [String, Number],

      default: 0,

    },

    label: {

      type: String,

      default: '',

    },

    teamId: {

      type: String,

      default: '',

    },

    conversationType: {

      type: String,

      default: '',

    },

    foldersId: {

      type: [String, Number],

      default: 0,

    },

  },

  setup() {

    const { uiSettings, updateUISettings } = useUISettings();

    const { accountId } = useAccount();



    return {

      uiSettings,

      updateUISettings,

      accountId,

    };

  },

  data() {

    return {

      showSearchModal: false,

    };

  },

  computed: {

    ...mapGetters({

      chatList: 'getAllConversations',

      currentChat: 'getSelectedChat',

    }),

    currentRouteConversationId() {

      return (

        this.conversationId ||

        this.$route.params.conversation_id ||

        this.$route.params.conversationId ||

        0

      );

    },

    showConversationList() {

      return this.isOnExpandedLayout ? !this.currentRouteConversationId : true;

    },

    showMessageView() {

      return this.currentRouteConversationId ? true : !this.isOnExpandedLayout;

    },

    isOnExpandedLayout() {

      const {

        LAYOUT_TYPES: { CONDENSED },

      } = wootConstants;

      const { conversation_display_type: conversationDisplayType = CONDENSED } =

        this.uiSettings;

      return conversationDisplayType !== CONDENSED;

    },

    shouldShowSidebar() {

      if (!this.currentChat.id) {

        return false;

      }

      const { is_contact_sidebar_open: isContactSidebarOpen } = this.uiSettings;

      return isContactSidebarOpen;

    },

  },

  watch: {

    conversationId(newVal) {

      if (newVal) this.fetchAndActivateConversation(newVal);

    },

    '$route.params.conversation_id'(newVal) {

      if (newVal) this.fetchAndActivateConversation(newVal);

    },

    '$route.params.conversationId'(newVal) {

      if (newVal) this.fetchAndActivateConversation(newVal);

    },

  },



  created() {

    if (!this.currentRouteConversationId) {

      this.$store.dispatch('clearSelectedState');

    }

  },



  mounted() {

    this.$store.dispatch('agents/get');

    this.$store.dispatch('portals/index');

    this.initialize();

  },



  methods: {

    onConversationLoad() {

      if (this.currentRouteConversationId) {

        this.fetchAndActivateConversation(this.currentRouteConversationId);

      }

    },

    initialize() {

      this.$store.dispatch('setActiveInbox', this.inboxId);

      if (this.currentRouteConversationId) {

        this.fetchAndActivateConversation(this.currentRouteConversationId);

      }

    },

    toggleConversationLayout() {

      const { LAYOUT_TYPES } = wootConstants;

      const {

        conversation_display_type:

          conversationDisplayType = LAYOUT_TYPES.CONDENSED,

      } = this.uiSettings;

      const newViewType =

        conversationDisplayType === LAYOUT_TYPES.CONDENSED

          ? LAYOUT_TYPES.EXPANDED

          : LAYOUT_TYPES.CONDENSED;

      this.updateUISettings({

        conversation_display_type: newViewType,

        previously_used_conversation_display_type: newViewType,

      });

    },

    async fetchAndActivateConversation(id) {
      if (!id) return;
      const convId = Number(id);
      try {
        let chat = this.findConversationById(convId);
        if (!chat || !chat.id || !chat.dataFetched) {
          const convData = await this.$store.dispatch('getConversation', convId);
          chat = convData || chat || this.findConversationById(convId);
        }
        if (chat && (chat.id || chat.display_id)) {
          const { messageId } = this.$route.query;
          await this.$store.dispatch('setActiveChat', {
            data: chat,
            after: messageId,
          });
          emitter.emit(BUS_EVENTS.SCROLL_TO_MESSAGE, { messageId });
          emitter.emit('ensure-conversation-tab', { conversation: chat });
        }
      } catch (error) {
        console.error('Error activating conversation:', error);
      }
    },

    findConversationById(convId) {

      const allConvs = this.$store.state.conversations.allConversations || [];

      const chat = allConvs.find(c => Number(c.id) === convId || Number(c.display_id) === convId);

      if (chat) return chat;

      const [chatFromList] = this.chatList.filter(c => Number(c.id) === convId || Number(c.display_id) === convId);

      return chatFromList || null;

    },

    onSearch() {

      this.showSearchModal = true;

    },

    closeSearch() {

      this.showSearchModal = false;

    },

  },

};

</script>



<template>

  <section class="flex w-full h-full min-w-0">

    <ChatList

      :show-conversation-list="showConversationList"

      :conversation-inbox="inboxId"

      :label="label"

      :team-id="teamId"

      :conversation-type="conversationType"

      :folders-id="foldersId"

      :is-on-expanded-layout="isOnExpandedLayout"

      @conversation-load="onConversationLoad"

    />

    <ConversationBox

      v-if="showMessageView"

      :inbox-id="inboxId"

      :is-on-expanded-layout="isOnExpandedLayout"

    >

      <SidepanelSwitch v-if="currentChat.id" />

    </ConversationBox>

    <ConversationSidebar v-if="shouldShowSidebar" :current-chat="currentChat" />

    <CmdBarConversationSnooze />

  </section>

</template>

